<template>
  <div
    id="app"
    :data-theme="$store.state.layout.themeBlack ? 'dark' : 'light'"
    :class="{ auth: isLoginPage }"
  >
    <preloader :loading="false" />
    <whole-header v-if="footerHeaderVisible" />
    <router-view />
    <modal-help v-if="$store.state.layout.modal.help.show" />
    <whole-footer v-if="footerHeaderVisible" />
  </div>
</template>

<script>
import preloader from '@/components/Preloader'
import wholeHeader from '@/components/Header'
import modalHelp from '@/components/modals/Help'
import wholeFooter from '@/components/Footer'

export default {
  components: {
    preloader,
    'whole-header': wholeHeader,
    'modal-help': modalHelp,
    'whole-footer': wholeFooter,
  },
  computed: {
    footerHeaderVisible() {
      return !this.isLoginPage
    },
    isLoginPage() {
      return this.$route.path.indexOf('/auth') >= 0
    },
  },
}
</script>

<style lang="scss">
@import './scss/_reset.scss';
@import './scss/_dark.scss';
@import './scss/_styles.scss';
</style>
